import { createTheme } from '@mui/material/styles';

export const styles = theme => ({
  checkBoxRoot: {
    color: '#ccc'
  },
  linearColorPrimary: {
    backgroundColor: '#ffd633',
  },
  linearBarColorPrimary: {
    backgroundColor: '#666666',
    borderRadius: 5,
  },
  linearRrogressRoot: {
  	height: 10,
	borderRadius: 5,
  },
  inputRoot: {
  	fontSize: 12,
  	fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  	color: '#999999',
  	'&:hover:not($disabled):not($error):not($focused):before': {
		borderBottom: '2px solid #666'
	},
},
  disabled: {},
  error: {},
  focused: {},
  underline: {
      '&:after': {
        borderBottom: '2px solid #666',
      }
  },
});

export const theme = createTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    // Name of the component ⚛️ / style sheet
    MuiFormLabel: {
      // Name of the rule
      root: {
        // Some CSS
        color: "#a6a6a6",
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        "&$focused": {
          color: "#666"
        }
      },
    },
  },
});

const priorityOverlay = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(59, 59, 59, 0.7)',
        zIndex: 110
    }

const commonOverlay = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(59, 59, 59, 0.7)',
        zIndex: 20
    }

const commonContent = {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: 10
}



export const modalStyles = {

/*
  solicitationModal : {
    content : Object.assign( {}, commonContent, { position: 'absolute', padding: 5 } ),
    overlay: commonOverlay
  },
  */
  singleLineModal : {
    content : Object.assign( {}, commonContent, { width: '350px', minHeight: '120px', overflow: 'hidden' }),
    overlay: priorityOverlay
  },
  doubleLineModal : {
    content : Object.assign( {}, commonContent, { width: '350px', minHeight: '120px', overflow: 'hidden' }),
    overlay: priorityOverlay
  },
  cloakModal : {
    content : Object.assign( {}, commonContent, { width: '350px', minHeight: '100px' }),
    overlay: commonOverlay
  },
  solReqModal : {
    content : Object.assign( {}, commonContent, { width: '90%', minHeight: '170px' }),
    overlay: commonOverlay
  },
  settingsModal : {
    content : Object.assign( {}, commonContent, { width : '90%', maxWidth: '640px', height: '540px' }),
    overlay: commonOverlay
  },
  userGroupModal : {
    content : Object.assign( {}, commonContent, { width : '90%', maxWidth: '640px', minHeight: '170px' }),
    overlay: commonOverlay
  },
  defaultAccountModal : {
    content : Object.assign( {}, commonContent, { width : '400px', height: '200px' }),
    overlay: commonOverlay
  }
}
